import { useMutation } from '@tanstack/react-query'

import { productUpdatesApi } from '../..'
import { SuccessResponse } from '../../productUpdateTypes'

export const SNOOZE_UPDATES_MUTATION_KEY = 'SNOOZE_UPDATES'

export const snoozeUpdates = async () => {
  const response =
    await productUpdatesApi.post<SuccessResponse<string>>('/me/snooze-updates')
  return response?.data?.data
}

export const useSnoozeUpdatesMutation = () => {
  return useMutation({
    mutationKey: [SNOOZE_UPDATES_MUTATION_KEY],
    mutationFn: snoozeUpdates
  })
}
